import React from 'react';
import { Testimonials, Problem } from './Sections1';
import { Product, Bonuses } from './Sections2';
import { Pricing } from './Sections3';
import { Guarantee, FAQ, CostOfInaction, Footer } from './Sections4';
export function BelowFold() {
  return <>
      <Testimonials data-id="element-5" data-mp="11c1f42slj0uz" />
      <Problem data-id="element-6" data-mp="wf189pnx9u2t" />
      <Product data-id="element-7" data-mp="wehuml5b1rul" />
      <Bonuses data-id="element-8" data-mp="wg2os9npj8rx" />
      <Pricing data-id="element-9" data-mp="wfkislb8tg6t" />
      <Guarantee data-id="element-10" data-mp="wcyb8locr0ol" />
      <FAQ data-id="element-11" data-mp="8pge0ambjae8" />
      <CostOfInaction data-id="element-12" data-mp="8p6y5fuzmjm9" />
      <Footer data-id="element-13" data-mp="8qi2phw9bvef" />
    </>;
}